import { render, staticRenderFns } from "./ViewLease.vue?vue&type=template&id=5cdde163&scoped=true&"
import script from "./ViewLease.vue?vue&type=script&lang=js&"
export * from "./ViewLease.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5cdde163",
  null
  
)

export default component.exports